/**
 * =============================================================================
 * IDS CRM Web - Help & Guides
 * =============================================================================
 *
 * A home for the team's how-to guides (Gareth 2026-08-02). Guides are
 * self-contained HTML files under /help/ in the web build (screenshots
 * embedded, demo data only), so adding a new one is: drop the file in
 * web/public/help/ and add a row to GUIDES below.
 *
 * =============================================================================
 */

import React from 'react';
import './Help.css';

const GUIDES = [
  {
    title: 'Reactive tickets & work logs',
    description:
      'Taking a support call with the one-form "Call handled" flow (close it or hand it '
      + 'over), logging work on open tickets, the site-work sections (job stages, van '
      + 'check, robot check, parts), and how completing a work log closes the ticket.',
    href: '/help/reactive-tickets-and-work-logs.html',
    updated: '2 Aug 2026'
  },
  {
    title: 'Adding customers, sites, distributors & depots',
    description:
      'Step-by-step with screenshots: create a new customer (the address becomes its '
      + 'Main Site automatically), add extra farm sites with Find Coordinates, set up a '
      + 'distributor, and manage its depots including the head office.',
    href: '/help/adding-customers-distributors-depots.html',
    updated: '1 Aug 2026'
  }
];

function Help() {
  return (
    <div className="help-page">
      <div className="help-header">
        <h1>Help &amp; Guides</h1>
        <p>How-to guides for the CRM. Each opens in a new tab and can be printed or saved as a PDF.</p>
      </div>

      <div className="help-guide-list">
        {GUIDES.map(guide => (
          <a
            key={guide.href}
            className="help-guide-card"
            href={guide.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="help-guide-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
              </svg>
            </div>
            <div className="help-guide-body">
              <span className="help-guide-title">{guide.title}</span>
              <span className="help-guide-description">{guide.description}</span>
              <span className="help-guide-meta">Updated {guide.updated} · Opens in a new tab</span>
            </div>
          </a>
        ))}
      </div>

      {/* Settings-for-everyone (2026-08-10): the customise screen moved two
          clicks deep, so it needs advertising a sidebar button didn't. */}
      <div className="help-footnote">
        <strong>Tip:</strong> your personal pages live under Settings — <em>My Profile</em> for
        your record, contact details and notifications, and <em>My Menu</em> to hide sidebar
        items you never use (they stay reachable under More on mobile). You sign in with
        Microsoft 365, so passwords are managed there.
      </div>

      <div className="help-footnote">
        Something missing or out of date? Tell Gareth — guides are rebuilt from live screenshots,
        so updating one is quick.
      </div>
    </div>
  );
}

export default Help;
